export const rem = (value: number) => `${value}rem` as `${number}rem`;
export const px = (value: number) => `${value}px` as `${number}px`;
export const em = (value: number) => `${value}em` as `${number}em`;
export const unitless = (value: number) => `${value}` as `${number}`;
